export const getRights = (state) => state.roles

